<template>
    <div>
        <v-card>
            <v-card-title class="d-flex justify-content-between w-100 mb-4">
                <h5>Organiser mes rubriques</h5>
                <v-btn icon @click="closeModal" class="ml-auto">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-simple-table class="cadh-option-table" v-if="optionLevels.length > 0">
                    <thead>
                    <tr>
                        <th>
                            Nom
                        </th>

                        <th>
                            Nombre d'options associées
                        </th>

                        <th>
                            Actions
                        </th>
                    </tr>
                    </thead>

                    <tbody v-for="level in optionLevels">
                    <tr>
                        <td>
                            <button @click="prepareUpdate(level)" class="text-primary">
                                {{ level.name }}
                            </button>
                        </td>

                        <td>
                            {{ level.options.length }}
                        </td>

                        <td>
                            <v-btn small icon color="primary" class="custom-button-error"
                                   @click="prepareUpdate(level)">
                                <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn small icon class="custom-button-error" @click="deleteLevel(level)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </v-simple-table>

                <div v-else>
                    <v-alert type="info"
                             text
                             class="container m-0 mr-3">
                        Les rubriques permettent d'organiser l'affichage de vos options en rubriques thématiques.
                    </v-alert>
                </div>

                <div class="text-center">
                    <v-btn class="default-button mt-12 mb-2 mx-auto" @click="prepareCreate">
                        Ajouter une rubrique
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>

        <v-dialog ref="dialog" v-model="createModal" width="700px">
            <v-card class="p-4">
                <v-text-field
                  outlined
                  label="Nom de la rubrique"
                  v-model="selectedLevel.name"
                  :class="{'input-error': submitted && (selectedLevel.name === null || selectedLevel.name === '') }"
                  hide-details
                  class="mb-2 mx-2"
                ></v-text-field>

                <v-card-actions class="pt-0 mt-4">
                    <v-spacer></v-spacer>
                    <v-btn @click="closeCreateModal">
                        Annuler
                    </v-btn>
                    <v-btn class="default-button" @click="checkName" v-if="modalType === 'creation'">
                        Créer
                    </v-btn>
                    <v-btn class="default-button" @click="checkName" v-else-if="modalType === 'update'">
                        Modifier
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import Confirm from "../../tools/Confirm.vue"

export default {
    name: "LevelModal",
    components: { Confirm },
    data() {
        return {
            levelHeaders: [
                {
                    text: "Nom",
                    value: "name",
                    width: "40%",
                },
                {
                    text: "Nombre d\'options associés",
                    value: "options.length",
                    width: "20%",
                },
                {
                    text: "Actions",
                    value: "actions",
                    sortable: false,
                    width: "20%",
                },
            ],
            createModal: false,
            selectedLevel: {
                name: "",
                parent: null,
            },
            submitted: false,
            modalType: null,
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setLevelModal"]),
        closeModal() {
            this.setLevelModal(false)
            this.submitted = false
            this.modalType = null
        },
        prepareCreate() {
            this.selectedLevel = {
                name: "",
                parent: null,
            }
            this.modalType = "creation"
            this.createModal = true
        },
        createLevel() {
            let payload = {
                "cadhConfigId": this.cadhConfig.id,
                "name": this.selectedLevel.name,
                "externalId": this.optionLevels.length + 1,
            }

            this.$global.loading = true

            this.$store.dispatch("cadhConfig/createOptionLevel", payload)

            this.closeCreateModal()

            this.$global.loading = false
        },
        prepareUpdate(level) {
            this.modalType = "update"
            this.selectedLevel = level

            this.createModal = true
        },
        updateLevel() {
            let payload = {
                "levelId": this.selectedLevel.id,
                "name": this.selectedLevel.name,
            }

            this.$global.loading = true

            this.closeCreateModal()

            this.$store.dispatch("cadhConfig/updateOptionLevel", payload)

            this.$global.loading = false
        },
        deleteLevel(item) {
            let message = "Voulez-vous vraiment supprimer cette rubrique ?"

            if (item.options.length > 0) {
                message = message + "<br>" + "Les " + item.options.length +
                  " options actuellement associées ne seront plus associé à aucune rubrique."
            }

            if (item.children.length > 0) {
                message = message + "<br>" + "Les sous rubriques seront également supprimées."
            }

            this.$refs.confirm.open("Attention", message,
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    this.$store.dispatch("cadhConfig/deleteOptionLevel", item.id)
                }
            })
        },
        checkName() {
            this.submitted = true
            let check = this.selectedLevel.name !== null && this.selectedLevel.name !== ""

            if (check && this.modalType === "creation") {
                this.submitted = false
                this.createLevel()
            } else if (check && this.modalType === "update") {
                this.submitted = false
                this.updateLevel()
            }
        },
        closeCreateModal() {
            this.submitted = false
            this.createModal = false
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "levelModal", "optionLevels"]),
    },
}
</script>